import { createContext } from "react";
import ProfileType from "./interfaces/profile";

type ContextType = {
    profile?: ProfileType,
    setProfile: (data: ProfileType) => void,
    selectedBranch?: number,
    setSelectedBranch: (data: number) => void,
};

export const ProfileContext = createContext<ContextType>({
    setProfile: (_: ProfileType) => {},
    setSelectedBranch: (_: number) => {},
});